<header class="masthead my-4">
    <div class="container my-3">
        <img src="../../assets/img/illustration-email-sent.png" width="320px" class="mx-auto d-block">
        <!-- <h3 class="text-center my-4">Your email id is verified..!</h3> -->
        <div class="text-center mt-4 mb-5">
            <button type="submit" class="btn custom-btn" (click)="gotoLogin()">Back to Login</button>
        </div>
    </div>
</header>